<template>
  <div class="product-row-view">
    <div id='filters' class="columns">
      <div class="column" v-show="false"></div>
      <div class="column filter is-justify-center"><label @click="$root.$emit('select_sort','name')"><strong>Nom machine</strong> <span
          class="fa fa-sort-amount-down-alt" :class="{'active':sort==='name/1'}"></span></label></div>
      <div class="column text-center"></div>
      <div class="category column" v-show="false"></div>
      <div
          v-for="attribute in filtersList"
          :key="attribute.attribute"
          :label-value="attribute.attribute"
          class="column filter"
      >
        <b-tooltip :label="attribute.title"
                   position="is-top">
          <label @click="$root.$emit('select_sort',attribute.attribute)"><strong>{{ attribute.title.substring(0,40) }}</strong><template v-if="attribute.title.length>40">[...]</template> <span
              class="fa" :class="{'active':sort===attribute.attribute+'/1' || sort===attribute.attribute+'/0', 'fa-sort-amount-down-alt': sort!==attribute.attribute+'/0' || sort===attribute.attribute+'/1', 'fa-sort-amount-down': sort===attribute.attribute+'/0'}"></span></label>

        </b-tooltip>
      </div>
      <div class="column" style="flex: 0 0 50px;"></div>
    </div>

    <div class="results">
        <card-machine-row
            v-for="(result, index) in results"
            :key="result.identifier+'-row'"
            :style="'order:'+index"
            :datas="result"
            :possible-attributes="filtersList"

            :class="{'is-bestseller': result.isBestSeller && $store.state.settings.region==='R1','is-new': result.isNew }"
        />
    </div>
  </div>
</template>

<script>
import CardMachineRow from "@/components/Card/CardMachineRow";
import {mapState} from "vuex";

export default {
  name: "RowView",
  components : {
    CardMachineRow
  },
  computed: {
    ...mapState({
      sort: state => state.searchMachines.sort,
      filtersList: state => state.searchMachines.filtersList,
      results: state => state.searchMachines.results,
    }),
  }
}
</script>

<style lang="scss" scoped>
#filters {
  width: 100%;
  border-radius: 20px 20px 0 0;
  background: $black;
  color: #ffffff;
  padding: 0 25px 0px;
  align-items: center;


  .filter {
    text-align: center;
    display: flex;

    label {
      cursor: pointer;
      display: flex;
      align-items: center;

      strong {
        text-align: left;
        font-size: 16px;
        display: flex;
        color: #ffffff;
        font-weight: normal;
      }

      span {
        text-align: right;
        display: flex;
        border-radius: 100%;
        background: #ffffff;
        color: $black;
        padding: 8px;
        margin-left: 5px;
        font-size: 18px;

        &.active {
          background: $brand-red;
          color: #ffffff;
        }
      }
    }
  }
}
</style>